import Vue from 'vue'
import SapphireVue from '@keicreations/sapphire-vue'

import ISapphireVueApi from '@/types/api/ISapphireVueApi.ts'
import SapphireGuard from '@/sapphire/guard.ts'

Vue.use(SapphireVue)

export { SapphireGuard, ISapphireVueApi }
